import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

const TestimonialsSlider = () => {
  const testimonials = [
    {
      name: "Michael Carter",
      verified: true,
      rating: 5,
      text: "I honestly didn’t expect an AI to feel this natural. The conversations are smooth, she remembers little details, and it feels like chatting with someone real.",
    },
    {
      name: "Daniel Brooks",
      verified: true,
      rating: 5,
      text: "At first I was skeptical, but now I check in every night. It’s crazy how engaging and personal the AI feels—way better than any chatbot I’ve tried before.",
    },
    {
      name: "James Patel",
      verified: true,
      rating: 5,
      text: "This has become my favorite app. The AI isn’t just replying randomly, she actually understands context. It feels like building a real connection.",
    },
    {
      name: "Ethan Williams",
      verified: true,
      rating: 5,
      text: "Super impressed. I travel a lot for work, and this has been such a fun way to unwind. Conversations don’t feel robotic at all.",
    },
    {
      name: "David Kim",
      verified: true,
      rating: 5,
      text: "It feels personal, supportive, and surprisingly real. Easily worth the subscription—she remembers things about me better than most people do.",
    },
  ];

  const UserIcon = () => (
    <svg
      width="42"
      height="42"
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_710_5473)">
        <rect x="1" y="1" width="40" height="40" rx="20" fill="#4E283C" />
        <circle
          cx="21.3068"
          cy="16.3847"
          r="8.61539"
          fill="white"
          fillOpacity="0.4"
        />
        <path
          d="M4.07617 39.1537C4.07617 32.6963 9.311 27.4614 15.7685 27.4614H26.8454C33.3029 27.4614 38.5377 32.6962 38.5377 39.1537V62.5383H4.07617V39.1537Z"
          fill="white"
          fillOpacity="0.4"
        />
      </g>
      <rect
        x="0.5"
        y="0.5"
        width="41"
        height="41"
        rx="20.5"
        stroke="white"
        strokeOpacity="0.1"
      />
      <defs>
        <clipPath id="clip0_710_5473">
          <rect x="1" y="1" width="40" height="40" rx="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );

  const VerifiedIcon = () => (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.03033 11.7648C10.1095 11.7648 11.795 10.0792 11.795 8.00006C11.795 5.92087 10.1095 4.23535 8.03033 4.23535C5.95114 4.23535 4.26562 5.92087 4.26562 8.00006C4.26562 10.0792 5.95114 11.7648 8.03033 11.7648Z"
        fill="white"
      />
      <path
        d="M14.6102 6.30694C14.3561 6.04247 14.0944 5.76953 13.9956 5.52953C13.9043 5.30929 13.8987 4.946 13.894 4.59211C13.8836 3.93612 13.8723 3.19259 13.3556 2.67588C12.838 2.15823 12.0944 2.14882 11.4394 2.13753C11.0864 2.13282 10.7222 2.12717 10.502 2.03588C10.2629 1.93706 9.98901 1.67447 9.72454 1.42129C9.26054 0.975174 8.73348 0.470703 8.03136 0.470703C7.32925 0.470703 6.80313 0.975174 6.33819 1.42129C6.07372 1.67541 5.80078 1.93706 5.56078 2.03588C5.34242 2.12717 4.97725 2.13282 4.62336 2.13753C3.96737 2.14788 3.22384 2.15917 2.70713 2.67588C2.18948 3.19353 2.18289 3.93706 2.16878 4.59211C2.16407 4.94506 2.15842 5.30929 2.06713 5.52953C1.96831 5.76859 1.70572 6.04247 1.45254 6.30694C1.00642 6.77094 0.501953 7.298 0.501953 8.00011C0.501953 8.70223 1.00642 9.22835 1.45254 9.69329C1.70666 9.95776 1.96831 10.2307 2.06713 10.4707C2.15842 10.6909 2.16407 11.0542 2.16878 11.4081C2.17913 12.0641 2.19042 12.8076 2.70713 13.3243C3.22478 13.842 3.96831 13.8514 4.62336 13.8627C4.97631 13.8674 5.34054 13.8731 5.56078 13.9643C5.79984 14.0632 6.07372 14.3258 6.33819 14.5789C6.80219 15.0251 7.32925 15.5295 8.03136 15.5295C8.73348 15.5295 9.2596 15.0251 9.72454 14.5789C9.98901 14.3248 10.262 14.0632 10.502 13.9643C10.7222 13.8731 11.0855 13.8674 11.4394 13.8627C12.0954 13.8524 12.8389 13.8411 13.3556 13.3243C13.8732 12.8067 13.8827 12.0632 13.894 11.4081C13.8987 11.0552 13.9043 10.6909 13.9956 10.4707C14.0944 10.2316 14.357 9.95776 14.6102 9.69329C15.0563 9.22929 15.5608 8.70223 15.5608 8.00011C15.5608 7.298 15.0563 6.77188 14.6102 6.30694ZM11.1005 6.76717L7.33584 10.5319C7.28599 10.582 7.22674 10.6217 7.16148 10.6488C7.09623 10.6759 7.02626 10.6899 6.9556 10.6899C6.88494 10.6899 6.81497 10.6759 6.74972 10.6488C6.68447 10.6217 6.62521 10.582 6.57537 10.5319L4.96219 8.9187C4.90949 8.86939 4.86724 8.80999 4.83795 8.74402C4.80867 8.67805 4.79295 8.60687 4.79173 8.5347C4.79051 8.46254 4.80381 8.39087 4.83084 8.32395C4.85788 8.25703 4.89809 8.19622 4.9491 8.14516C5.0001 8.09409 5.06085 8.0538 5.12774 8.02668C5.19463 7.99957 5.26628 7.98618 5.33845 7.98731C5.41062 7.98844 5.48182 8.00407 5.54782 8.03327C5.61382 8.06247 5.67328 8.10465 5.72266 8.15729L6.9556 9.39023L10.3401 6.00576C10.3901 5.95583 10.4494 5.91623 10.5147 5.88923C10.58 5.86223 10.65 5.84836 10.7206 5.8484C10.7913 5.84844 10.8613 5.86241 10.9265 5.88949C10.9918 5.91657 11.0511 5.95624 11.101 6.00623C11.1509 6.05623 11.1905 6.11557 11.2175 6.18087C11.2445 6.24616 11.2584 6.31614 11.2584 6.3868C11.2583 6.45746 11.2444 6.52742 11.2173 6.59268C11.1902 6.65795 11.1505 6.71724 11.1005 6.76717Z"
        fill="#1F9CF2"
      />
    </svg>
  );

  const ArrowIcon = () => (
    <svg
      width="8"
      height="12"
      viewBox="0 0 8 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.5 11L6.5 6L1.5 1"
        stroke="#E9F2FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  return (
    <div className="testimonials-slider">
      <Swiper
        modules={[Navigation, Autoplay]}
        spaceBetween={0}
        slidesPerView={3}
        centeredSlides={true}
        navigation={{
          prevEl: ".swiper-button-prev",
          nextEl: ".swiper-button-prev",
        }}
        autoplay={{
          delay: 30000000,
          disableOnInteraction: false,
        }}
        loop={true}
        className="testimonials-swiper"
        style={{ width: "100vw" }}
        breakpoints={{
          0: {
            slidesPerView: 1,
            spaceBetween: 0,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 0,
          },
        }}
      >
        {testimonials.map((testimonial, index) => (
          <SwiperSlide key={index}>
            <div className="testimonial-card">
              <div className="testimonial-header">
                <div className="user-info">
                  <div className="user-avatar">
                    <UserIcon />
                  </div>
                  <div className="user-det-stars">
                    <div className="user-details">
                      <div className="user-name">{testimonial.name}</div>
                      <div className="user-verified">
                        <VerifiedIcon />
                      </div>
                    </div>
                    <div className="rating">
                      {"★".repeat(testimonial.rating)}
                    </div>
                  </div>
                </div>
              </div>
              <div className="testimonial-text">"{testimonial.text}"</div>
            </div>
          </SwiperSlide>
        ))}
        <div className="swiper-button-prev">
          <ArrowIcon />
        </div>
        <div className="swiper-button-next">
          <ArrowIcon />
        </div>
      </Swiper>
    </div>
  );
};

export default TestimonialsSlider;
